import { render, staticRenderFns } from "./Capture.vue?vue&type=template&id=27a9cfff&scoped=true"
import script from "./Capture.vue?vue&type=script&lang=js"
export * from "./Capture.vue?vue&type=script&lang=js"
import style0 from "./Capture.vue?vue&type=style&index=0&id=27a9cfff&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a9cfff",
  null
  
)

export default component.exports